import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const slides = [{
  id: 1,
  image: 'https://cdn.magicpatterns.com/uploads/9VyhTvqZo41VFyqJcPkcTi/pasted-image.png',
  title: 'Private Tastings',
  subtitle: 'Curated Wine Experiences, Education & Culture',
  ctas: [{
    label: 'Book a Tasting',
    href: '/contact'
  }, {
    label: 'Explore Experiences',
    href: '/services'
  }]
}, {
  id: 2,
  image: 'https://cdn.magicpatterns.com/uploads/iM1Ccn2mutuKGWsubnPVgg/IMG_2580.jpg',
  title: 'Culinary Pairings',
  subtitle: 'Elevate your palate with expert pairings',
  ctas: [{
    label: 'Book a Tasting',
    href: '/contact'
  }, {
    label: 'Explore Experiences',
    href: '/services'
  }]
}, {
  id: 3,
  image: 'https://cdn.magicpatterns.com/uploads/5UMoLu6MWMS4g3pnjys7XA/IMG_4005.jpg',
  title: 'Wine Education',
  subtitle: 'Deepen your knowledge of the vine',
  ctas: [{
    label: 'Book a Tasting',
    href: '/contact'
  }, {
    label: 'Explore Experiences',
    href: '/services'
  }]
}];
export function Hero() {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);
  const next = () => setCurrent(prev => (prev + 1) % slides.length);
  const prev = () => setCurrent(prev => (prev - 1 + slides.length) % slides.length);
  return <section className="relative h-screen w-full overflow-hidden bg-black" data-id="element-113">
      <AnimatePresence data-id="element-114">
        <motion.div key={current} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 1
      }} className="absolute inset-0" data-id="element-115">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: `url(${slides[current].image})`
        }} data-id="element-116">
            <div className="absolute inset-0 bg-black/30" data-id="element-117" />
          </div>

          <div className="relative h-full flex flex-col items-center justify-center text-center px-4 max-w-5xl mx-auto" data-id="element-118">
            <motion.h1 initial={{
            y: 20,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} transition={{
            delay: 0.5,
            duration: 0.8
          }} className="text-white mb-6" data-id="element-119">
              {slides[current].title}
            </motion.h1>

            <motion.p initial={{
            y: 20,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} transition={{
            delay: 0.65,
            duration: 0.8
          }} className="text-sm md:text-lg text-white/90 font-medium mb-12 tracking-[0.3em] uppercase max-w-2xl" data-id="element-120">
              {slides[current].subtitle}
            </motion.p>

            <motion.div initial={{
            y: 20,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} transition={{
            delay: 0.8,
            duration: 0.8
          }} className="flex flex-wrap justify-center gap-6" data-id="element-121">
              {slides[current].ctas.map((cta, idx) => <button key={idx} onClick={() => navigate(cta.href)} className="border border-white text-white px-10 py-4 rounded-full hover:bg-white hover:text-[#4A0E0E] transition-colors" data-id="element-122">
                  {cta.label}
                </button>)}
            </motion.div>
          </div>
        </motion.div>
      </AnimatePresence>

      <button onClick={prev} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/70 hover:text-white transition-colors" data-id="element-123">
        <ChevronLeft size={48} data-id="element-124" />
      </button>
      <button onClick={next} className="absolute right-4 top-1/2 -translate-y-1/2 text-white/70 hover:text-white transition-colors" data-id="element-125">
        <ChevronRight size={48} data-id="element-126" />
      </button>
    </section>;
}